/* BEZELOR photo popup: full-screen viewer with left/right arrows, finger swipe, keyboard keys and a counter.
   Used for review photos on the tracking page (/apps/parcelpanel) and on product pages. */
(() => {
  if (window.BzLightbox) return;

  const css = `
.bzlb{position:fixed;inset:0;width:100vw;max-width:none;height:100dvh;max-height:none;margin:0;padding:0;border:0;background:transparent;color:#fff;overflow:hidden}
.bzlb:not([open]){display:none}
.bzlb::backdrop{background:rgba(10,8,5,.92);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px)}
.bzlb__stage{position:absolute;inset:0;overflow:hidden;touch-action:pan-y;user-select:none;-webkit-user-select:none;cursor:grab}
.bzlb__stage.is-drag{cursor:grabbing}
.bzlb__track{display:flex;height:100%;will-change:transform;transition:transform .38s cubic-bezier(.22,.8,.2,1)}
.bzlb__stage.is-drag .bzlb__track{transition:none}
.bzlb__slide{flex:0 0 100%;display:grid;place-items:center;height:100%;padding:0}
.bzlb__slide img{display:block;width:auto;height:auto;max-width:calc(100vw - 32px);max-height:calc(100dvh - 156px);object-fit:contain;border-radius:14px;box-shadow:0 30px 70px -20px rgba(0,0,0,.8);pointer-events:none;opacity:0;transform:scale(.97);transition:opacity .3s,transform .3s}
.bzlb__slide img.is-in{opacity:1;transform:none}
.bzlb__btn{position:absolute;z-index:3;display:grid;place-items:center;width:48px;height:48px;padding:0;border:1px solid rgba(243,220,149,.55);border-radius:50%;cursor:pointer;color:#f3dc95;background:rgba(18,15,10,.78);-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);box-shadow:0 12px 24px -10px rgba(0,0,0,.8);transition:transform .2s,background .2s,opacity .2s;-webkit-tap-highlight-color:transparent}
.bzlb__btn:hover{background:rgba(40,33,22,.92);transform:scale(1.07)}
.bzlb__btn:active{transform:scale(.94)}
.bzlb__btn:focus-visible{outline:3px solid #f3dc95;outline-offset:3px}
.bzlb__btn svg{width:22px;height:22px;fill:none;stroke:currentColor;stroke-width:2;stroke-linecap:round;stroke-linejoin:round}
.bzlb__x{top:14px;right:14px;width:44px;height:44px}
.bzlb__prev,.bzlb__next{top:50%;margin-top:-24px}
.bzlb__prev{left:12px}
.bzlb__next{right:12px}
.bzlb__btn[hidden]{display:none}
.bzlb__btn.is-off{opacity:.3;pointer-events:none}
.bzlb__count{position:absolute;z-index:3;left:50%;bottom:22px;transform:translateX(-50%);padding:8px 16px;border:1px solid rgba(243,220,149,.4);border-radius:999px;background:rgba(18,15,10,.78);color:#f6ecd2;font:700 12.5px/1 'Jost',system-ui,sans-serif;letter-spacing:.16em}
.bzlb__count[hidden]{display:none}
@media(max-width:600px){.bzlb__prev,.bzlb__next{top:auto;bottom:14px;margin:0}.bzlb__prev{left:16px}.bzlb__next{right:16px}.bzlb__slide img{max-height:calc(100dvh - 170px)}}
@media(prefers-reduced-motion:reduce){.bzlb__track,.bzlb__slide img,.bzlb__btn{transition:none}}
`;

  const arrow = (d) => `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${d}"/></svg>`;
  let dlg, track, stage, prev, next, count, urls = [], idx = 0, w = 1;

  const build = () => {
    const st = document.createElement('style');
    st.textContent = css;
    document.head.appendChild(st);
    dlg = document.createElement('dialog');
    dlg.className = 'bzlb';
    dlg.setAttribute('aria-label', 'Photo viewer');
    dlg.innerHTML =
      '<div class="bzlb__stage"><div class="bzlb__track"></div></div>' +
      '<button type="button" class="bzlb__btn bzlb__x" aria-label="Close photo">' + arrow('M6 6l12 12M18 6 6 18') + '</button>' +
      '<button type="button" class="bzlb__btn bzlb__prev" aria-label="Previous photo">' + arrow('M15 5l-7 7 7 7') + '</button>' +
      '<button type="button" class="bzlb__btn bzlb__next" aria-label="Next photo">' + arrow('M9 5l7 7-7 7') + '</button>' +
      '<div class="bzlb__count" aria-live="polite"></div>';
    document.body.appendChild(dlg);
    stage = dlg.querySelector('.bzlb__stage');
    track = dlg.querySelector('.bzlb__track');
    prev = dlg.querySelector('.bzlb__prev');
    next = dlg.querySelector('.bzlb__next');
    count = dlg.querySelector('.bzlb__count');

    dlg.querySelector('.bzlb__x').addEventListener('click', () => dlg.close());
    prev.addEventListener('click', () => go(idx - 1));
    next.addEventListener('click', () => go(idx + 1));
    dlg.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
    });
    dlg.addEventListener('close', () => { track.innerHTML = ''; urls = []; });

    /* finger / mouse swipe: the photo follows the finger, then snaps to the next or back */
    let sx = 0, sy = 0, dx = 0, t0 = 0, down = false, locked = null, moved = false;
    stage.addEventListener('pointerdown', (e) => {
      if (e.button > 0 || urls.length < 2) return;
      down = true; locked = null; moved = false; sx = e.clientX; sy = e.clientY; dx = 0; t0 = e.timeStamp; w = stage.clientWidth || 1;
    });
    stage.addEventListener('pointermove', (e) => {
      if (!down) return;
      const mx = e.clientX - sx, my = e.clientY - sy;
      if (locked === null && (Math.abs(mx) > 6 || Math.abs(my) > 6)) locked = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
      if (locked !== 'x') return;
      moved = true;
      if (!stage.classList.contains('is-drag')) { stage.classList.add('is-drag'); try { stage.setPointerCapture(e.pointerId); } catch (_) {} }
      dx = mx;
      /* a little resistance at either end */
      const edge = (idx === 0 && dx > 0) || (idx === urls.length - 1 && dx < 0);
      track.style.transform = 'translate3d(' + (-idx * w + (edge ? dx * 0.3 : dx)) + 'px,0,0)';
    });
    const end = (e) => {
      if (!down) return;
      down = false;
      stage.classList.remove('is-drag');
      const fast = Math.abs(dx) / Math.max(1, e.timeStamp - t0) > 0.45;
      if (locked === 'x' && (Math.abs(dx) > w * 0.16 || (fast && Math.abs(dx) > 24))) go(idx + (dx < 0 ? 1 : -1)); else go(idx);
    };
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    /* tapping the dark area (not the photo) closes */
    stage.addEventListener('click', (e) => { if (!moved && e.target.tagName !== 'IMG') dlg.close(); moved = false; });
    window.addEventListener('resize', () => { if (dlg.open) go(idx); });
  };

  const load = (i) => {
    const im = track.children[i] && track.children[i].firstElementChild;
    if (!im || im.src) return;
    im.referrerPolicy = 'no-referrer';
    im.onload = () => im.classList.add('is-in');
    im.onerror = () => im.classList.add('is-in');
    im.src = im.dataset.src;
  };

  function go(i) {
    if (!urls.length) return;
    idx = Math.max(0, Math.min(urls.length - 1, i));
    w = stage.clientWidth || 1;
    track.style.transform = 'translate3d(' + (-idx * w) + 'px,0,0)';
    load(idx); load(idx + 1); load(idx - 1);
    const many = urls.length > 1;
    prev.hidden = next.hidden = count.hidden = !many;
    prev.classList.toggle('is-off', idx === 0);
    next.classList.toggle('is-off', idx === urls.length - 1);
    count.textContent = (idx + 1) + ' / ' + urls.length;
  }

  window.BzLightbox = {
    open(list, start) {
      const clean = (list || []).filter(Boolean);
      if (!clean.length) return;
      if (!dlg) build();
      urls = clean;
      track.innerHTML = urls.map((u) => '<div class="bzlb__slide"><img alt="" draggable="false" data-src="' + u.replace(/"/g, '&quot;') + '"></div>').join('');
      if (!dlg.open) dlg.showModal();
      track.style.transition = 'none';
      go(start || 0);
      requestAnimationFrame(() => { track.style.transition = ''; });
      dlg.focus();
    }
  };

  /* ---- hooks ---- */
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;

    /* tracking page review cards */
    const pic = t.closest('[data-bzt-pic]');
    if (pic) {
      const group = Array.from((pic.closest('.bzt-rv__pics') || pic.parentElement).querySelectorAll('[data-bzt-pic]'));
      e.preventDefault(); e.stopImmediatePropagation();
      window.BzLightbox.open(group.map((b) => b.dataset.bztPic), group.indexOf(pic));
      return;
    }

    /* product page: Judge.me review photos (the photo strip and the photos inside each review) */
    const slot = t.closest('.bezelor-pdp-review-app-slot');
    if (!slot) return;
    const item = t.closest('.jm-media-grid__item, .jm-media-thumbnail-list__thumbnail');
    if (!item || !item.querySelector('img')) return;
    const scope = item.matches('.jm-media-grid__item') ? slot.querySelector('.jm-media-grid') : item.closest('.jm-review-item');
    if (!scope) return;
    const sel = item.matches('.jm-media-grid__item') ? '.jm-media-grid__item' : '.jm-media-thumbnail-list__thumbnail';
    const items = Array.from(scope.querySelectorAll(sel)).filter((n) => n.querySelector('img'));
    const src = (n) => { const im = n.querySelector('img'); return im.dataset.fullSrc || im.currentSrc || im.src; };
    e.preventDefault(); e.stopImmediatePropagation();
    window.BzLightbox.open(items.map(src), items.indexOf(item));
  }, true);
})();
